document.addEventListener('DOMContentLoaded', function() {
    // Get all share containers
    const shareContainers = document.querySelectorAll('.share-container');
    
    // Close all tooltips except the clicked one
    function closeOtherTooltips(currentContainer) {
        shareContainers.forEach(container => {
            if (container !== currentContainer) {
                container.querySelector('.share-tooltip').classList.remove('active');
            }
        });
    }
    
    // Handle share button click
    shareContainers.forEach(container => {
        const shareButton = container.querySelector('.share-button');
        const tooltip = container.querySelector('.share-tooltip');
        
        shareButton.addEventListener('click', function(e) {
            e.stopPropagation();
            closeOtherTooltips(container);
            tooltip.classList.toggle('active');
        });
    });
    
    // Close tooltips when clicking outside
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.share-container')) {
            shareContainers.forEach(container => {
                container.querySelector('.share-tooltip').classList.remove('active');
            });
        }
    });
});